import { Component, Input } from '@angular/core';

import { User } from '../user';

@Component({
  selector: 't-user-admin',
  templateUrl: './admin.component.html',
})
export class UserAdminComponent {

  @Input()
  user: User
}
